import { missingInput, divisionByZero, ambiguousMetricRole } from '../warnings';
import { formulaOk, formulaUnknown, type FormulaResult } from './types';

/**
 * SPEC-008 §29/METRIC-REQ-009 — ROAS = attributed revenue / media investment.
 * `usedAvailableInvestmentBasis` is set by the caller when no media-cost vs.
 * total-cost distinction exists in this funnel, forcing a basis warning
 * rather than silently pretending the distinction was made.
 */
export function roas(
  attributedRevenue: number | null,
  mediaInvestment: number | null,
  usedAvailableInvestmentBasis = false,
): FormulaResult {
  const explanation = {
    metric: 'roas',
    formula: 'attributedRevenue / mediaInvestment',
    inputs: { attributedRevenue, mediaInvestment },
    result: null,
  };
  if (attributedRevenue === null || mediaInvestment === null) {
    return formulaUnknown(explanation, [missingInput('Attributed revenue and media investment are both required to calculate ROAS.')]);
  }
  if (mediaInvestment === 0) {
    return formulaUnknown(explanation, [divisionByZero('ROAS is undefined when media investment is zero.')]);
  }
  const warnings = usedAvailableInvestmentBasis
    ? [ambiguousMetricRole('No media-cost vs. total-cost distinction exists; ROAS used all available investment.')]
    : [];
  return formulaOk(attributedRevenue / mediaInvestment, { ...explanation, result: attributedRevenue / mediaInvestment }, warnings);
}
